export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker.27f00b2c.worker.js");
}
